import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmationService } from 'primeng/primeng';

import { Perfis } from '../../../models/perfis';
import { InscricaoService } from '../../../services/inscricao.service';
import { AuthService } from '../../admin/auth.service';
import { CandidatoService } from '../../candidato/candidato.service';
import { FaseService } from '../../fase/fase.service';
import { FaseUnidadeService } from '../../faseUnidade/faseUnidade.service';
import { WebPage } from '../../shared/web-page';

import { ExcelService } from '../../../services/excel.service';
import { Fase } from '../../../models/fase';
import { EnumTipoEdital } from '../../../models/tipo-edital';

@Component({ templateUrl: './convocar-aluno.component.html' })
export class ConvocarAlunoComponent extends WebPage implements OnInit {
  candidatos = [];
  candidatosSelecionados = [];
  classificacoes = [];
  faseUnidade: any = {};
  fases = [];
  fase: Fase = null;
  form: FormGroup = {} as FormGroup;
  perfis: any = {};
  periodos = [];
  unidades = [];
  usuario: any = {};

  constructor(
    messageService: MessageService,
    private authService: AuthService,
    private candidatoService: CandidatoService,
    private confirmationService: ConfirmationService,
    private faseService: FaseService,
    private faseUnidadeService: FaseUnidadeService,
    private fb: FormBuilder,
    private inscricaoService: InscricaoService,
    private excelService: ExcelService,
  ) {
    super(messageService);
  }

  ngOnInit() {
    this.usuario = this.authService.informacoesUsuario();
    this.perfis = Perfis;
    this.obterFases();
    this.obterClassificacoes();
    this.obterPeriodos();
    this.criarForm();
    this.verificarPerfil();
  }

  private criarForm() {
    this.form = this.fb.group({
      idFase: ['', [Validators.required]],
      idUnidade: ['', [Validators.required]],
      idClassificacao: ['', [Validators.required]],
      idPeriodo: ['', [Validators.required]]
    });
  }

  pesquisar() {
    this.candidatos = [];
    this.candidatosSelecionados = [];

    this.messageService.clear();

    if (
      this.idFase.invalid &&
      this.idUnidade.invalid &&
      this.idClassificacao.invalid
    ) {
      return;
    }

    this.obterFaseUnidade(
      this.idFase.value,
      this.idUnidade.value,
      this.idClassificacao.value
    );
  }

  convocar() {
    this.messageService.clear();

    if (this.form.invalid) {
      return;
    }

    if (this.candidatosSelecionados.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Deve ser selecionado pelo menos um registro.'
      });
      return;
    }

    if (
      this.candidatosSelecionados.length > this.faseUnidade.nroVagas ||
      this.faseUnidade.vagasLivres === 0
    ) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail:
          'O número de alunos informado é maior que o número de vagas disponíveis.'
      });
      return;
    }

    this.confirmationService.confirm({
      message: 'Deseja realmente convocar os alunos selecionados?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        const candidatosConvocados = {
          periodo: this.idPeriodo.value,
          idsCandidatos: this.candidatosSelecionados.map((x) => x.idCandidato)
        };

        this.candidatoService.convocaCandidatos(candidatosConvocados).subscribe(
          () => {
            this.obterFaseUnidade(
              this.idFase.value,
              this.idUnidade.value,
              this.idClassificacao.value
            );
            this.obterCandidatos(
              this.idFase.value,
              this.idUnidade.value,
              this.idClassificacao.value
            );
          },
          (e) => this.gerenciaErro(e)
        );
      }
    });
  }

  obterFases() {
    //this.faseService.getAll().subscribe((x) => (this.fases = x));
    if(this.usuario.Perfil == Perfis.GestorUnidadeOperacional || this.usuario.Perfil == Perfis.AdministrativoUnidadeOperacional){
      this.faseService.getByEditalUnidade(EnumTipoEdital.IdPessoaJuridica,this.usuario.IdUnidade).subscribe((x) => (this.fases = x));
    } else {
      this.faseService.getByEdital(EnumTipoEdital.IdPessoaJuridica).subscribe((x) => (this.fases = x));
    }
  }

  obterUnidades(idFase) {
    if (!idFase) {
      this.unidades = [];
      return;
    }

    this.faseService.getFull(idFase).subscribe((x) => {
      if(this.usuario.Perfil == Perfis.GestorUnidadeOperacional || this.usuario.Perfil == Perfis.AdministrativoUnidadeOperacional){
        this.unidades = x.unidades.filter((f)=> {
          return f.idUnidade == this.usuario.IdUnidade;
        })
      } else this.unidades = x.unidades;
      console.log(this.unidades);
      this.fase = x;
      this.unidades.sort(this.sortUnidades);
      if (
        this.usuario.Perfil !== this.perfis.AdministrativoUnidadeOperacional &&
        this.usuario.Perfil !== this.perfis.GestorUnidadeOperacional
      ) {
        this.idUnidade.reset();
        this.idUnidade.setValue('');
      }
    });
  }

  sortUnidades(obj1, obj2) {
    let a = obj1;
    let b = obj2;
    if (a.tipologia < b.tipologia) return -1;
    else if (a.tipologia === b.tipologia) return 0;
    else if (a.tipologia > b.tipologia) return 1;
  }
  obterClassificacoes() {
    this.inscricaoService
      .getListaClassificacao()
      .subscribe((x) => (this.classificacoes = x));
  }

  obterPeriodos() {
    this.periodos = [
      { descricao: 'Manhã', valor: 'manha' },
      { descricao: 'Tarde', valor: 'tarde' }
    ];
  }

  obterFaseUnidade(idFase, idUnidade, idClassificacao) {
    this.playLoading();
    this.faseUnidade.nroVagas = 'Carregando...';
    this.faseUnidade.nroConvocadosUnidade = 'Carregando...';
    this.faseUnidade.vagasLivres = 'Carregando...';
    this.faseUnidadeService
      .getByFaseUnidadeClassificacao(idFase, idUnidade, idClassificacao)
      .subscribe(
        (x) => (this.faseUnidade = x),
        (e) => {
          this.gerenciaErro(e);
          this.faseUnidade.nroVagas = '';
          this.faseUnidade.nroConvocadosUnidade = '';
          this.faseUnidade.vagasLivres = '';
        },
        () => this.obterCandidatos(
          this.idFase.value,
          this.idUnidade.value,
          this.idClassificacao.value
        )
      );
  }

  obterCandidatos(idFase, idUnidade, idClassificacao) {
    this.candidatoService
      .getInscritosComPosicaoDentroDasVagasByFaseUnidadeClassificacao(
        idFase,
        idUnidade,
        idClassificacao
      )
      .subscribe(
        (x) => (this.candidatos = this.orderByPosicao(x)),
        (e) => this.gerenciaErro(e),
        () => this.stopLoading()
      );
  }

  private orderByPosicao(list: Array<any>): Array<any> {
    list.sort((a, b) => {
      if (a.posicao === null) {
        return 1;
      }
      if (b.posicao === null) {
          return -1;
      }

      if (a.posicao < b.posicao) {
        return -1;
      } else if (a.posicao > b.posicao) {
        return 1;
      }
      return 0;
   })
   list.forEach((_, i) => {
    list[i].posicao =  list[i].posicao ? list[i].posicao + "°" : "";
  })
    return list;
  }

  private verificarPerfil() {
    if (
      this.usuario.Perfil === this.perfis.GestorUnidadeOperacional ||
      this.usuario.Perfil === this.perfis.AdministrativoUnidadeOperacional
    ) {
      this.form.controls.idUnidade.setValue(this.usuario.IdUnidade);
    }
  }

  get idFase() {
    return this.form.controls.idFase;
  }
  get idUnidade() {
    return this.form.controls.idUnidade;
  }
  get idClassificacao() {
    return this.form.controls.idClassificacao;
  }
  get idPeriodo() {
    return this.form.controls.idPeriodo;
  }

  baixarExcel(){
    this.criarExcelRelatorioDetalhado(this.candidatos);
  }

  criarExcelRelatorioDetalhado(candidatos: any): void {
    const relatorio = [];
    const fase = this.fases.filter(fase => fase.idFase == this.faseUnidade.idFase);
    const unidade = this.unidades.filter(unidade => unidade.idUnidade == this.faseUnidade.idUnidade);
    candidatos.forEach((x) => {
      relatorio.push({
        Fase: `${fase[0].nomeFase}`,
        Unidade: `${unidade[0].unidade.tipologia} - ${unidade[0].unidade.nomeUnidade}`,
        Cnpj:x.cnpj,
        Empresa: x.razaoSocial,
        Nome:x.nome,
        CPF: this.getCpfLGPD(x.cpf),
        telefone:x.telefonePreferencial,
        telefoneOp1:x.telefoneOpcional1,
        telefoneOp2:x.telefoneOpcional2,
        Email: x.email,
        CEP: x.cep,
        UF: x.uf,
        Cidade: x.cidade,
        Bairro: x.bairro,
        Logradouro: x.logradouro,
        Numero: x.numero,
      });
    });

    this.excelService.exportAsExcelFile(relatorio,`${fase[0].nomeFase} - ${unidade[0].unidade.tipologia}_${unidade[0].unidade.nomeUnidade} - Candidatos a convocar`);
  }

  private getCpfLGPD(dado:string):string {
    return `XXX.${dado.substring(3,6)}.${dado.substring(6,9)}-XX`;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/etapa/convocar-aluno/convocar-aluno.component.ts